@use '@css/variables';

.intro {
  p {
    line-height: 1.7;
  }
}

.hint {
  margin-bottom: 0;
}

.examples {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 1.25rem;
  margin-top: 0.5rem;

  .example {
    position: relative;
    margin: 0;
    padding: 1.5rem 1.5rem 1.5rem 3.5rem;
    background-color: white;
    border: 1px solid var(--beigedarker);
    border-radius: var(--border-radius);
    line-height: 1.7;
    // keeps the line breaks of the example texts
    white-space: pre-line;
    break-inside: avoid;

    // decorative opening quote
    &::before {
      content: '\201C';
      position: absolute;
      top: 0.9rem;
      left: 1.1rem;
      color: var(--primary);
      font-family: Georgia, serif;
      font-size: 3rem;
      line-height: 1;
      opacity: 0.45;
    }
  }
}

// [naam], [datum]: the parts the reader fills in themselves
.placeholder {
  padding: 0.1em 0.4em;
  color: var(--primary);
  background-color: var(--lilac);
  border-radius: var(--border-radius);
  font-size: 0.9em;
  white-space: nowrap;
}

.closing {
  p {
    line-height: 1.7;
  }

  .action {
    margin-top: 1.5rem;
  }

  .chevron {
    margin-left: 0.5rem;
  }
}

.help {
  padding: 2.5rem 0;
}

@media only screen and (min-width: variables.$md-breakpoint) {
  // columns instead of a grid, so cards of different lengths stack without gaps
  .examples {
    display: block;
    column-count: 2;
    column-gap: 1.5rem;

    .example {
      margin-bottom: 1.5rem;
    }
  }
}
